import React from "react";
import {Link} from 'gatsby';
import BackButtons from "../common/backbuttons";

export const PERSONAL_TAG = "Riguardo me"
class MainTagsMapSection extends React.Component {

    static get PERSONAL_TAG() {
        return PERSONAL_TAG
    }

    constructor(props) {
        super(props);
    }

    digestPosts(tagsPosts) {
        let results = new Map()
        if(Array.isArray(tagsPosts.edges)) {
            tagsPosts.edges.map(({node:postItem},i) => {
                let tags = postItem.data.tags
                if(Array.isArray(tags)) {
                    tags.map(({tag:tagItem},z) => {
                        let count=1
                        if(results.has(tagItem.slug)) {
                            let tagStored = results.get(tagItem.slug)
                            count = tagStored.count + 1
                        }
                        results.set(tagItem.slug,{
                            "area":tagItem.document[0].data.area,
                            "slug":tagItem.slug,
                            "label":tagItem.document[0].data.label,
                            "count":count
                        })
                    })
                }                
            })
        }

        if(results.size > 0) {
            let resultsByArea = new Map()
            results.forEach(tagItem => {
                let areaArray = []
                if(resultsByArea.has(tagItem.area)) {
                    areaArray=resultsByArea.get(tagItem.area)
                }
                areaArray.push(tagItem)
                resultsByArea.set(tagItem.area,areaArray)
            });
            if(resultsByArea.has(MainTagsMapSection.PERSONAL_TAG)) {
                let personalArray = resultsByArea.get(MainTagsMapSection.PERSONAL_TAG)
                resultsByArea.delete(MainTagsMapSection.PERSONAL_TAG)
                results=new Map()
                results.set(MainTagsMapSection.PERSONAL_TAG, personalArray)
                resultsByArea.forEach ((v,k) => { results.set(k,v) });
            } else {
                results=resultsByArea
            }            
        }
        
        const resultObj = {};
        results.forEach ((v,k) => { resultObj[k] = v });
        return resultObj
    }

    renderTagLabel(tag) {
        let labelToPrint = ""
        if(tag.label)
            labelToPrint = tag.label
        else
            labelToPrint = tag.slug
        
        return `${labelToPrint} (${tag.count})`
    }

    render() {
        const {tagsByPosts} = this.props
        let postsByTag = this.digestPosts(tagsByPosts)
        return (
            <section className="wrapper style1 align-center">
                <div className="inner" style={{paddingBottom:0}}>
                    <h2>Tags Map</h2>
                    <p>Scegli un argomento dalla lista, divisa fra articoli personali e report di viaggio</p>
                </div>
                <div className="items style1 medium onscroll-fade-in">
                    {Object.keys(postsByTag).map((area, z) => (
                        <section key={z}><div className="inner">
                        <h3>{area}</h3>
                        <p className="tagsmap">
                        {postsByTag[area].map((tagItem, k) => (
                            <Link key={k} to={`/tag/${tagItem.slug}`}>#{this.renderTagLabel(tagItem)}</Link>
                        ))}
                        </p>
                        </div>
                        </section>

                    ))}
                </div>
                <BackButtons backElement="topElements"/>
            </section>
        )
    }
}
export default MainTagsMapSection